import { useRouter } from "next/router";
import { useEffect } from "react";
import { UrlObject } from "url";

interface IProps {
    to: UrlObject | string;
}

export const Redirect: React.FC<IProps> = ({ to }) => {
    const router = useRouter();
    useEffect(() => {
        router.replace(to);
    }, [to, router]);
    return null;
};
